import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import { BacnetExplorer } from '../features/BacnetExplorer'
import { useParams, useSearchParams } from 'react-router-dom';
import HierarchyPage from "../components/HierarchyPage";

const BacnetExplorerPage = () => {

    const prms = useParams();
    const { edgeDeviceId,deviceId: deviceIdStr,moduleId  } = prms;
    var deviceId = -1;
    if (deviceIdStr) deviceId = parseInt(deviceIdStr);

    const [searchParams, setSearchParams]  = useSearchParams();
    const resourceGroupId = searchParams.get("resourceGroupId");

    const links = [
        //{ href: "/edgedevices", name: 'Edge Devices', isCurrent: false },
        //{ href: `/edgedevices/${edgeDeviceId}`, name: edgeDeviceId, isCurrent: false },
        //{ href: `/edgedevices/${edgeDeviceId}/${deviceId}`, name: deviceId.toString(), isCurrent: true }
        { href: ``,  name: `Edge Devices > ${edgeDeviceId} > ${deviceId}`, isCurrent: true }
    ]

    return (
        <HierarchyPage links={links} header='BACnet Explorer' showNavigateBack >
            { edgeDeviceId && deviceId >= 0 && moduleId && resourceGroupId && <BacnetExplorer resourceGroupId={resourceGroupId} edgeDeviceId={edgeDeviceId} deviceId={deviceId} moduleId={moduleId} />}
        </HierarchyPage >
    )
}


export default withAITracking(reactPlugin, BacnetExplorerPage);
